export default __webpack_public_path__ + "static/bg-innovation--mobile-bfba4dd8105ea9312ea11e899dfb6212.jpg";